import axios from "axios";


export const http4014 = axios.create({
    baseURL: process.env.REACT_APP_BOT_CLEAR,
});
